<ion-header>
  <ion-toolbar>
    <ion-title>WisdomVault Pages</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="ion-padding">
    <h2>Facebook Pages from WisdomVault</h2>
    
    <div *ngIf="loading">
      <p>Loading pages...</p>
    </div>
    
    <div *ngIf="error">
      <p style="color: red;">{{error}}</p>
      <ion-button (click)="loadPages()">Retry</ion-button>
    </div>
    
    <div *ngIf="!loading && !error">
      <p>Total pages: {{pages.length}}</p>
      
      <ion-list>
        <ion-item *ngFor="let page of pages">
          <ion-label>
            <h3>{{page.page_name}}</h3>
            <p>Username: {{page.username}}</p>
            <p>Tier: {{page.tier}}</p>
          </ion-label>
        </ion-item>
      </ion-list>
    </div>
  </div>
</ion-content>